<template>
    <div class="solutions" v-loading="loading">
        <div class="carousel" v-if="isShow && imagList?.length">
            <CarouselPage :imagList="imagList" />
        </div>

        <Section title="智慧农业 解决方案" v-if="isShow">
            <div class="cards">
                <div v-if="_dataLength === 0"><el-empty :image-size="120" description="暂无内容..."/></div>
                <div class="flex_card_box" v-else>
                    <CardMoudle3 :categoryId="categoryId" :isShow="isShow" />
                </div>
            </div>
        </Section>

        <div class="cards" v-else>
            <div v-if="_dataLength === 0"><el-empty :image-size="120" description="暂无内容..."/></div>
            <div class="flex_card_box" v-else>
                <CardMoudle3 :categoryId="categoryId" :isShow="isShow" />
            </div>
            <div v-if="_dataLength > 6" class="more-button" @click="getMore()">
                <el-button style="width: calc(490 * var(--groot-ui-rpx)); height: calc(60 * var(--groot-ui-rpx));">
                    <span style="font-size: calc(20 * var(--groot-ui-rpx));">查看更多</span>
                </el-button>
            </div>
        </div>

        <ContactFooter v-if="isShow" />
    </div>
</template>

<script setup>
import CarouselPage from '../components/carouselPage.vue';
import Section from '../components/Section.vue';
import CardMoudle3 from './components/cardMoudle3.vue';
import ContactFooter from '../components/contactFooter.vue';
import { ref, onMounted } from 'vue';
import router from '@/router';
import { useStore } from '@/store/index';
const store = useStore();

const imagList = ref([]);
const categoryId = ref('1666653706550321163');
const _dataLength = ref(0);
const loading = ref(false)

const props = defineProps({
    isShow: {
        type: Boolean,
        required: true,
        default: true
    }
});

onMounted(() => {
    localStorage.setItem('previousRoute', '智慧农业方案');
    getInfo();
});

const getInfo = async () => {
    loading.value = true
    const _solutionsData = store.allData['/solutions']
    _dataLength.value = _solutionsData?.filter(v => v.contentType !== 'banner').length;
    // 轮播图
    const _bannerImage = _solutionsData?.find(v => v.contentType === 'banner')?.contentImg;
    imagList.value = _bannerImage || []
    loading.value = false
};

const getMore = () => {
    router.push({ path: '/moreView', query: { id: categoryId.value, type: 'solutions' } });
};
</script>

<style lang="less" scoped>
.solutions {
    .carousel {
        margin-top: calc(10 * var(--groot-ui-rpx));
        margin-bottom: calc(75 * var(--groot-ui-rpx));
    }

    .cards {
        margin: 0 auto;
        overflow: hidden;
    }

    .flex_card_box {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        overflow: hidden;
        padding-top: calc(5 * var(--groot-ui-rpx));
    }

    .more-button {
        margin: calc(30 * var(--groot-ui-rpx)) auto;
    }
}
</style>
